/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import Drawer from "../../components/drawer";
import Sidebar from "../../components/sidebar";
import { Formik } from "formik";
import * as Yup from "yup";
import api from "../../utils/api";
import { toast } from "react-toastify";
import { useUserStore } from "../../storesZustand/useUserStore";
import { ModalTypes } from "../../components/all-modal-window/modal-window";
import ModalPermanentlyRemoveUser from "../../components/all-modal-window/modal-permanentlyRemoveUser";
import BreadcrumbsComponent from "../../components/UI/breadcrumbs";

const fileTypes = ["JPG", "PNG", "GIF"];
const Settings = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [user, setUser] = useUserStore((state) => [
    state.user,
    state.setUsersDataAfterLogin,
  ]);

  const [isLoading, setIsLoading] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [location, setLocation] = useState();
  const [showdrag, setshowdrag] = useState(false);
  const token = localStorage?.getItem("token");

  // Define breadcrumbs array
  const breadCrumbsArr = [
    { name: "Home", url: "/" },
    { name: "Settings", url: "/settings" },
  ];

  useEffect(() => {
    const updateScreenWidth = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", updateScreenWidth);
    if (token) {
      api
        .post("/location/location")
        .then((res) => {
          if (res.status === 200) {
            setLocation(res?.data.data);
          } else {
            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);

  const [file, setFile] = useState(null);
  const handleChange = (file) => {
    setFile(file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setImagePreview(reader.result);
    };
  };

  const [isOpen, setIsOpen] = useState(false);
  const fileref = useRef(null);

  const handleChangeimg = () => {
    const reader = new FileReader();
    reader.readAsDataURL(fileref.current.files[0]);
    reader.onload = function () {
      setImagePreview(reader.result);
    };
  };

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const SettingsSchema = Yup.object().shape({
    firstname: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    surname: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
  });

  const handleDeleteAccount = () => {
    setShowModalDelete(true);
  };

  const handleDeleteAccountPermanently = async () => {
    return api.get("/user/deleteMyAccountPermanently");
  };

  return (
    <React.Fragment>
      <div className="w-[100%]">
        <Drawer isOpen={isOpen} toggleDrawer={toggleDrawer} />
        <div className="w-[250px] xl:flex hidden">
          <Sidebar />
        </div>
        <div className=" xl:w-[calc(100%-240px)] w-[100%] xl:ml-[240px] bg-[#f7f7f7] flex justify-between ">
          <div className="w-[100%]  md:px-[47px] px-[20px] pt-[35px] pb-[100px]">
            <div
              className={`w-full h-[40px] flex flex-row justify-between items-center py-2 px-2 ${
                screenWidth <= 640 || screenWidth >= 1025 ? "hidden" : "block"
              }`}
            >
              <button onClick={() => toggleDrawer()}>
                <img src="/images/burger-open.svg" alt="burger" />
              </button>
            </div>
            {screenWidth < 640 && (
              <div className="fixed z-30 top-0 left-0 w-full h-[88px] bg-white flex flex-row justify-between items-center py-7 px-5">
                <button onClick={() => toggleDrawer()}>
                  <img src="/images/burger-open.svg" alt="burger" />
                </button>
              </div>
            )}
            <div className={`${screenWidth < 640 ? "mt-14" : ""}`}>
              <BreadcrumbsComponent breadCrumbsArr={breadCrumbsArr} />
              <div className="mt-9">
                <div className="shadow-2xl rounded-lg	px-10 py-10 w-full lg:h-[200px] bg-white">
                  <Formik
                    enableReinitialize
                    validationSchema={SettingsSchema}
                    initialValues={{
                      firstname: user?.first_name,
                      surname: user?.last_name,
                    }}
                    onSubmit={(values, actions) => {
                      setIsLoading(true);
                      const { firstname, surname } = values;

                      api
                        .patch(
                          `/user/updateUser`,
                          { first_name: firstname, last_name: surname },
                          {
                            headers: {
                              "x-auth-token": token,
                            },
                          }
                        )
                        .then((res) => {
                          setIsLoading(false);
                          if (res.status === 200) {
                            localStorage.setItem(
                              "user",
                              JSON.stringify(res?.data?.data)
                            );
                            setUser(res?.data?.data);
                            toast.success(res?.data.message);
                          }
                        })
                        .catch((err) => {
                          toast.error(err);
                          setIsLoading(false);
                        });
                    }}
                  >
                    {(props) => (
                      <form onSubmit={props.handleSubmit} id="form-settings">
                        {user?.role !== "employee" ? (
                          <>
                            {/* <div className="flex items-center mb-2">
                              <span className="inline pr-1">Project Photo</span>
                              <span>
                                <img
                                  src={"images/star.png"}
                                  className="rounded-sm	"
                                />
                              </span>
                            </div>
                            <div className="grid md:grid-cols-3  grid-cols-1 rounded-lg bg-[#F8F9FA] p-3 border-dashed border-2 border-[#DEE2E6] ">
                              <div className="file">
                                <label
                                  htmlFor="photo"
                                  className="text-[#3D475C] text-[14px] font-semibold "
                                >
                                  <img
                                    className="md:w-[120px] w-[50px]  md:mx-0 mx-auto md:py-0 py-3 rounded-sm cursor-pointer "
                                    src={
                                      imagePreview
                                        ? imagePreview
                                        : user?.picture
                                    }
                                  />
                                </label>
                                <input
                                  type="file"
                                  className="hidden"
                                  id="photo"
                                  ref={fileref}
                                  name="photo"
                                  onChange={handleChangeimg}
                                />
                              </div>
                              <div className="col-span-2">
                                <FileUploader
                                  label="OR Drag & Drop  "
                                  handleChange={handleChange}
                                  name="file"
                                  types={fileTypes}
                                  classes="fileuploaderwiwdth"
                                />
                              </div>
                            </div> */}
                          </>
                        ) : (
                          <input
                            type="file"
                            className="hidden"
                            id="photo"
                            ref={fileref}
                            name="photo"
                            onChange={handleChangeimg}
                          />
                        )}
                        <div className="grid md:grid-cols-2  grid-cols-1 gap-4  py-5">
                          <div className="firstname_input">
                            <label
                              htmlFor="firstname"
                              className="text-[#3D475C] text-[14px] font-semibold "
                            >
                              <div className="flex items-center pb-2">
                                <span className="inline pr-1 ">First Name</span>
                                <span>
                                  <img
                                    src="images/star.png"
                                    className="rounded-sm	"
                                  />
                                </span>
                              </div>
                            </label>
                            <input
                              type="text"
                              id="firstname"
                              className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              onChange={props.handleChange}
                              onBlur={props.handleBlur}
                              placeholder="Jhon"
                              value={props.values.firstname}
                              name="firstname"
                            />

                            {props.errors.firstname && props.touched && (
                              <div
                                id="feedback"
                                className="text-[12px] text-red-500	"
                              >
                                {props.errors.firstname}
                              </div>
                            )}
                          </div>
                          <div className="surname_input">
                            <div className="surname_input">
                              <label
                                htmlFor="surname_input"
                                className="text-[#3D475C] text-[14px] font-semibold "
                              >
                                <div className="flex items-center pb-2">
                                  <span className="inline pr-1 ">Surname</span>
                                  <span>
                                    <img
                                      src="images/star.png"
                                      className="rounded-sm	"
                                    />
                                  </span>
                                </div>
                              </label>
                              <input
                                type="text"
                                id="surname"
                                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                onChange={props.handleChange}
                                onBlur={props.handleBlur}
                                value={props.values.surname}
                                name="surname"
                                placeholder="Guillane"
                              />
                            </div>
                            {props.errors.surname && props.touched && (
                              <div
                                id="feedback"
                                className="text-[12px] text-red-500	"
                              >
                                {props.errors.surname}
                              </div>
                            )}
                          </div>
                        </div>
                      </form>
                    )}
                  </Formik>
                  <div className="flex flex-1 justify-end">
                    <button
                      className="text-[#6C757D] text-[14px] px-6 py-2 rounded-md bg-[#E9ECEF]"
                      onClick={handleDeleteAccount}
                    >
                      Permanently Delete Account
                    </button>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 py-10 justify-items-end	">
                  <div></div>
                  <div className="grid grid-cols-2 2xl:w-[40%] lg:w-[65%] md:w-[90%] w-full justify-items-center justify-end	">
                    <div></div>
                    <div>
                      <button
                        type="submit"
                        form="form-settings"
                        className="text-[#fff] bg-[#E4A40C] text-[14px] px-6 py-2 rounded-md min-w-[120px]" // Adjust min-w-[150px] as needed
                      >
                        {isLoading ? (
                          <div role="status" className="mx-auto w-[30px]">
                            <svg
                              aria-hidden="true"
                              className="w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-[#E4A61A]"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                              />
                            </svg>
                          </div>
                        ) : (
                          <span>Save Changes</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalPermanentlyRemoveUser
        isOpen={showModalDelete}
        setIsOpen={setShowModalDelete}
        handleConfirm={handleDeleteAccountPermanently}
      />
    </React.Fragment>
  );
};

export default Settings;
